
 
import React, { useEffect } from 'react'
import Event from './eventImg/event-20-feb.webp'


const Event34 = () => {
    useEffect(() => {
        document.title = "ISHRAE Knowledge Talk on Oxygen & IAQ - The Invisible threat";
      }, []);
  return (
    <>
    <div className='eventheading'>

      <h1 className='text-center'>20 February 2026</h1>
        <h3 className='text-center'>ISHRAE Knowledge Talk on Oxygen & IAQ - The Invisible threat  </h3>
</div>
   <div className='container' id='calanderevent'>
    <img src={Event} alt='ISHRAE Knowledge Talk on Oxygen & IAQ - The Invisible threat'/>
     <button className='mb-4'><a href='https://ishraehq.in/Admin/CalenderEventMaster/Registration_new/u8tC13qFHhY=' target='_blank'>Register Now </a></button>
    </div>
    </>
  )
}

export default Event34




